// The three lists of Master Data › Employees: people posted at a store, people who are
// not, and people who left in the last three months. Shared by the page's shell
// (EmployeeMasterPage), which draws them in its one row beside Custom Fields, and by the
// roster itself (EmployeesPage), which holds the lists and their counts.
import { UserCheck, UserMinus, UserX } from 'lucide-react';
import type { MasterTab } from '../components/MasterTabStrip';

export type RosterTab = 'deployed' | 'undeployed' | 'inactive';

/** Each list's count as its tab shows it. Null: not known (Inactive before it is first opened). */
export type RosterCounts = Record<RosterTab, number | null>;

/** The three roster tabs, in order, with the counts given (none when `counts` is null). */
export const rosterTabs = (counts: RosterCounts | null): MasterTab<RosterTab>[] => [
  { key: 'deployed', label: 'Deployed Employees', icon: UserCheck, count: counts?.deployed ?? null },
  { key: 'undeployed', label: 'Undeployed Employees', icon: UserMinus, count: counts?.undeployed ?? null },
  {
    key: 'inactive',
    label: 'Inactive Employees',
    icon: UserX,
    count: counts?.inactive ?? null,
    title: 'Employees marked inactive in 1Office in the last 3 months',
  },
];
